import React from "react";
const KS10SectionCHeader = () => {
  return (
    <div className="row mx-0">
      <div className="col-sm-12 col-md-12 col-lg-12 section-box">
        <div className="kr-title">
          <div className="form-check disabled">
            <input className="form-check-input" type="radio" disabled />
            <label className="form-check-label pl-3 pr-4">Section C</label>
          </div>
        </div>
        <div className="personal-details">
          <span className="title pr-3">Late opt-out</span>
          <div className="blockletterrs-whitebox">
            <div className="blockletterrs-use">Read the notes on the back of this form </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default KS10SectionCHeader;
